<template>
   <div>
     <apexchart ref="myChart" width="100%" :height="this.height ? this.height : 320" type="line" :options="chartOptions" :series="series"></apexchart>
   </div>
</template>

<script>
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

export default {
    props:['categories', 'chartdata', 'height', 'legend'],
    data: function() {
      return {
        chartOptions: {
            chart: {
                id: 'linechart',
                toolbar: {
                    show: false,
                    tools:{
                        download:false // <== line to add
                    }
                },
                zoom: {
                    enabled: false
                },
                animations: {
                    enabled: false
                },
                type: 'line',
            },
            yaxis: {
                // categories: this.categories,
                // logarithmic: true,
                // labels: {
                //     style: {
                //         colors: '#FFF'
                //     }
                // },
            },
            xaxis: {
                categories: this.categories,
                // labels: {
                //     style: {
                //         colors: '#FFF'
                //     }
                // }
            },
            dataLabels: {
              enabled: true,
            },
            stroke: {
                curve: 'smooth'
            },
            legend: {
                show: this.legend ? true : false,
                position: 'bottom',
                horizontalAlign: 'center',
                floating: false,
                offsetY: 0,
                offsetX: 0
            },
            colors: ["#0cbcf2", "#003565", "#7041e5", "#b8c3d0", "#beaeff"]
        },
        series: this.chartdata
        // series: [{
        //   name: 'series-1',
        //   data: this.chartdata
        // }],
      }
    },
    watch: {
        categories: (newVal, oldVal) => {
            // this.$nextTick(() => {
            //     this.$refs.myChart.refresh();
            // });
        },
        series: (newVal, oldVal) => {
            // this.$nextTick(() => {
            //     this.$refs.myChart.refresh();
            // });
        }
    }
};
</script>